import { StatusVariant } from '@factorialco/factorial-one-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface TranscriptStatusProps {
  isConnected: boolean | undefined
  connectionError: string | null
}
export const getTranscriptStatus = ({ isConnected, connectionError }: TranscriptStatusProps) => {
  if (connectionError) return i18n.t('meetings.room.transcript.recording_error')
  if (isConnected) return i18n.t('meetings.room.transcript.recording')
  return i18n.t('meetings.room.transcript.recording_not_connected')
}

export const getTranscriptStatusTooltip = ({
  isConnected,
  connectionError,
}: TranscriptStatusProps) => {
  if (connectionError) return i18n.t('meetings.room.transcript.recording_error_tooltip')
  if (isConnected) return i18n.t('meetings.room.transcript.recording_tooltip')
  return i18n.t('meetings.room.transcript.recording_not_connected_tooltip')
}

export const getTranscriptStatusVariant = ({
  isConnected,
  connectionError,
}: TranscriptStatusProps): StatusVariant => {
  if (connectionError) return 'critical'
  if (isConnected) return 'positive'
  return 'neutral'
}
